import { fetchWithAuth } from '../../../auth'
import { useState, useRef } from 'react'
import dayjs from '../../../utils/dayjsConfig'

export const useFetchClients = (baseBackendUrl, currentDbRef = null) => {
  const [clientOptions, setClientOptions] = useState([])
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const abortController = useRef(null)

  const fetchClients = async (searchTerm = '', pageNumber = 1) => {
    if (loading) return
    setLoading(true)

    if (pageNumber === 1) {
      if (abortController.current) abortController.current.abort()
      abortController.current = new AbortController()
    }

    try {
      const url = `${baseBackendUrl}/clients?q=${encodeURIComponent(searchTerm)}&active=true&page=${pageNumber}&per_page=25`

      const response = await fetchWithAuth(url, {
        method: 'GET',
        signal: abortController.current?.signal
      })

      const data = response.json ? await response.json() : response

      const newOptions = (data.table || []).map((cl) => {
        const hasListAssigned = cl.price_list && cl.price_list.trim() !== ""

        const assignedToOtherList =
          hasListAssigned && cl.price_list !== currentDbRef

        return {
          value: cl.db_ref,
          label: `${cl.db_ref} - ${cl.name}`,
          name: cl.name,
          active: cl.active,
          address: cl.address,
          price_list: assignedToOtherList ? cl.price_list : null,
          created_at: cl.created_at || dayjs().toISOString(),
        }
      })

      setClientOptions((prev) =>
        pageNumber === 1 ? newOptions : [...prev, ...newOptions]
      )

      if (pageNumber * 25 < (data.count || 0)) setPage((prev) => prev + 1)
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error fetching clients:', error)
      }
    } finally {
      setLoading(false)
    }
  }

  const handleSearchChange = (term) => {
    setPage(1)
    if (term.trim().length < 3) fetchClients('', 1)
    else fetchClients(term, 1)
  }

  return { clientOptions, loading, page, fetchClients, handleSearchChange, setClientOptions }
}
